// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__24uRh","colMin":"styles_colMin__1B2Xm","colCheckbox":"styles_colCheckbox__2HhrV"};